import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, take, tap } from 'rxjs/operators';
import { ApplicationService } from '../../services/application/application.service';
import { StepNavigationService } from '../../services/step-navigation/step-navigation.service';
import { ApplicationStateService } from '../../services/application-state/application-state.service';
import { navigateToHome } from '../../../../../core/resolver/shared/functions/navigate-to-home.function';

export const FrnFilingInitializerResolver = (route: ActivatedRouteSnapshot) => {
    const applicationService = inject(ApplicationService);
    const stepService = inject(StepNavigationService);
    const applicationStateService = inject(ApplicationStateService);
    const router = inject(Router);

    const applicationId = route.firstChild?.paramMap.get('id');

    if (!applicationId) {
        /**
         * When no Application ID exists in the route, the application state should be cleared.
         * Without a valid ID, there is no corresponding application, and retaining the previous
         * state could cause components to display stale information.
         */
        applicationStateService.clearApplicationState();
        stepService.initializeNewFrnFilingSteps();
        return of(true);
    }

    return applicationService.getApplicationState(applicationId).pipe(
        take(1),
        tap(() => {
            stepService.initializeFrnFilingSteps(applicationId);
        }),
        map(() => true),
        catchError((err) => {
            console.error(
                'Error initializing FRN filing page for application:',
                applicationId,
                err,
            );

            return navigateToHome(router);
        }),
    );
};
